<template>
  <div>
    <BaseEchart :option="option" :width="width" :height="height"></BaseEchart>
  </div>
</template>

<script>
import BaseEchart from "@/components/base-echart/base-echart.vue";

export default {
  components: {
    BaseEchart,
  },
  props: {
    xData: {
      type: Array,
    },
    values: {
      type: Array,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  computed: {
    option() {
      return {
        tooltip: {
          trigger: "axis",
          confine: false,
        },

        title: {
          left: "center",
          // text: 'Large Area Chart'
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "3%",
          width: "95%",
          height: "100%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
          offset: 0,
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0, //使x轴文字显示全
            // 首尾缩进
          },
          axisLine: {
            onZero: false,
          },
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
        },
        series: [
          {
            name: "点击量",
            type: "line",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "#1e80ff",
            },
            areaStyle: {
              color: "#409eff",
            },
            data: this.values,
          },
        ],
      };
    },
  },
};
</script>
